import React from 'react'
import { FormControl, FormGroup, Row, Col, ControlLabel } from 'react-bootstrap'
import i18next from 'i18next'
import Notificator from './Notificator'
import Button from './Button'

import styles from './styles/app.scss'
import loginStyles from './styles/login.scss'

import illustration from './../assets/images/wopi-wide.png'

export default class Login extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      email: ''
    }
  }

  render() {
    const { params, isEmailExisting } = this.props

    const isSent = params.state == 'sent'

    return (
      <section className={loginStyles.login}>
        <Row>
          <Col sm={6} smOffset={3} md={4} mdOffset={4}>
            <h1>{i18next.t('forgot_password')}</h1>

            {!isSent && (
              <form>
                <div className={styles.informationFormGroup}>
                  <FormGroup>
                    <ControlLabel>{i18next.t('email')}</ControlLabel>
                    <FormControl
                      type="email"
                      value={this.state.email}
                      placeholder={i18next.t('email_address')}
                      name="email"
                      onChange={this.onChange.bind(this)}
                    />
                  </FormGroup>
                </div>

                {isEmailExisting === false && (
                  <Notificator type="error">
                    {i18next.t('no_account_found_with_this_email')}
                  </Notificator>
                )}

                <p>
                  <Button
                    text={i18next.t('send_link_to_email')}
                    onClick={e => this.sendResetPasswordMail(e)}
                  />
                </p>
              </form>
            )}
          </Col>
        </Row>

        {isSent && (
          <Row>
            <Col md={8} mdOffset={2}>
              <div style={{ marginTop: 10 }}>
                <Notificator type="success">
                  <header>{i18next.t('check_your_mail')}</header>

                  <p>{i18next.t('password_reset_sent')}</p>
                </Notificator>
              </div>
            </Col>
          </Row>
        )}

        <p>
          <img src={illustration} alt="WOPI" />
        </p>
      </section>
    )
  }

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  sendResetPasswordMail(e) {
    e.preventDefault()

    this.props.onSendResetPasswordMail(this.state.email)
  }
}



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js